import { useState, useEffect, useRef } from "react";
import axios from "axios";

function AdminAssessmentRegister() {

  const token = localStorage.getItem("access");

  const [classes, setClasses] = useState([]);

  const [selectedClass, setSelectedClass] = useState("");

  const [registerData, setRegisterData] = useState(null);

  const printRef = useRef();

  useEffect(() => {

    fetchClasses();

  }, []);

  const fetchClasses = async () => {

    try {

      const res = await axios.get(
        "https://api.eduskot.com/api/academics/classes/",
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setClasses(res.data);

    } catch (err) {

      console.error(err);

    }
  };

  const fetchRegister = async (classId) => {

    try {

      const res = await axios.get(
        `https://api.eduskot.com/api/results/assessment-register/?class_id=${classId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setRegisterData(res.data);

    } catch (err) {

      console.error(err);

    }
  };

  const handleClassChange = (e) => {

    const value = e.target.value;

    setSelectedClass(value);

    if (value) {

      fetchRegister(value);

    }
  };

  const printRegister = () => {

    const printContents =
      printRef.current.innerHTML;

    const win = window.open(
      "",
      "",
      "width=1200,height=900"
    );

    win.document.write(`
      <html>
      <head>

      <title>
      Assessment Register
      </title>

      <style>

      body{
        font-family:Arial;
        padding:20px;
      }

      table{
        width:100%;
        border-collapse:collapse;
      }

      th,td{
        border:1px solid #000;
        padding:8px;
        text-align:center;
      }

      </style>

      </head>

      <body>

      ${printContents}

      </body>

      </html>
    `);

    win.document.close();

    win.print();
  };

  return (

    <div style={{ padding:"40px" }}>

      <div
        style={{
          display:"flex",
          justifyContent:"space-between",
          marginBottom:"20px"
        }}
      >

        <h1>
          Assessment Register
        </h1>

        <div>

          <button
            onClick={printRegister}
            style={{
              padding:"10px 18px",
              background:"#16a34a",
              color:"white",
              border:"none",
              borderRadius:"8px",
              marginRight:"10px"
            }}
          >
            Print
          </button>

          <button
  onClick={() =>
    window.location.href =
    "/admin-dashboard"
  }
  style={{
    padding:"10px 18px",
    background:"#2563eb",
    color:"white",
    border:"none",
    borderRadius:"8px",
    cursor:"pointer",
    fontWeight:"600"
  }}
>
  Back
</button>

        </div>

      </div>

      <select
        value={selectedClass}
        onChange={handleClassChange}
        style={{
          width:"100%",
          padding:"12px",
          marginBottom:"20px"
        }}
      >

        <option value="">
          Select Class
        </option>

        {classes.map((c) => (

          <option key={c.id} value={c.id}>
    {c["department__name"]
        ? `${c.name} (${c["department__name"]})`
        : c.name}
</option>

        ))}

      </select>

      {registerData && (

<div
  ref={printRef}
  style={{
    background:"white",
    padding:"30px",
    border:"1px solid #ddd"
  }}
>

  <div
    style={{
      textAlign:"center",
      marginBottom:"25px"
    }}
  >
    <h1
      style={{
        margin:0,
        fontSize:"32px"
      }}
    >
      {registerData.school_name}
    </h1>

    <h2
      style={{
        marginTop:"15px"
      }}
    >
      ASSESSMENT REGISTER
    </h2>
  </div>

  <div
    style={{
      display:"flex",
      justifyContent:"space-between",
      marginBottom:"25px",
      fontSize:"18px"
    }}
  >
    <span>
      Academic Year:
      {" "}
      {registerData.session}
    </span>

    <span>
      Class:
      {" "}
      {registerData.class}
    </span>
  </div>

  <div
    style={{
      marginBottom:"25px",
      fontSize:"18px",
      lineHeight:"40px"
    }}
  >
    <div>
      Subject:
      ____________________________________
    </div>

    <div>
      Teacher:
      ____________________________________
    </div>
  </div>

  <table
    style={{
      width:"100%",
      borderCollapse:"collapse"
    }}
  >

    <thead>

      <tr>

        <th style={thStyle}>
          No
        </th>

        <th
          style={{
            ...thStyle,
            minWidth:"250px"
          }}
        >
          Student Name
        </th>

        {registerData.assessments.map(
          (assessment,index)=>(

          <th
            key={index}
            style={thStyle}
          >
            {assessment}
          </th>

        ))}

      </tr>

    </thead>

    <tbody>
  {[...registerData.students]
    .sort((a, b) =>
      (a.full_name || "").localeCompare(
        b.full_name || "",
        undefined,
        { sensitivity: "base" }
      )
    )
    .map((student, index) => (
      <tr key={student.id}>
        <td style={tdStyle}>
          {index + 1}
        </td>

        <td
          style={{
            ...tdStyle,
            textAlign: "left"
          }}
        >
          {student.full_name}
        </td>

        {registerData.assessments.map((_, i) => (
          <td
            key={i}
            style={{
              ...tdStyle,
              height: "45px"
            }}
          />
        ))}
      </tr>
    ))}
</tbody>

  </table>

</div>

)}

    </div>
  );
}

const thStyle = {
  border:"1px solid black",
  padding:"10px",
  textAlign:"center",
  background:"#f5f5f5",
  fontWeight:"bold"
};

const tdStyle = {
  border:"1px solid black",
  padding:"10px"
};

export default AdminAssessmentRegister;